import React from 'react';
import classnames from 'classnames';
import PulsingHeart from '../../../pulsingHeart/pulsingHeart';
import favouritesButtonStyles from './favouritesButton.module.pcss';
import productsStyles from '../../products.module.pcss';
import { FavouritesToggler } from '../../hooks/useFavouritesHandler';
import isTouchSupported from '../../../../../../helpers/isTouchSupported';

const { isFavouritesEnabled = false } = window.bbGlobal.miniFavouritesData || {};

interface FavouritesButtonProps {
  productCode: string;
  isFavourite: boolean;
  handleFavouritesClick: FavouritesToggler;
}

const isTouch = isTouchSupported();

function FavouritesButton({
  productCode,
  isFavourite,
  handleFavouritesClick
}: FavouritesButtonProps): React.ReactElement | null {
  return isFavouritesEnabled ? (
    <button
      data-target-desktop
      type="button"
      className={classnames(
        favouritesButtonStyles['favourites-button'],
        productsStyles['favourites-button'],
        isFavourite && favouritesButtonStyles['favourites-button--active'],
        isTouch && favouritesButtonStyles['favourites-button--touch']
      )}
      onClick={(): void => handleFavouritesClick(isFavourite, productCode)}
    >
      <PulsingHeart isOn={isFavourite} />
    </button>
  ) : null;
}

export default FavouritesButton;
